var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"navbar navbar-expand navbar-light bg-white mb-3"},[_c('button',{staticClass:"btn btn-sidebar",attrs:{"type":"button"},on:{"click":_vm.showSidebar}},[_c('i',{staticClass:"icon-menu"})]),_c('div',{staticClass:"navbar-brand text-primary"},[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }